import { css } from "@linaria/core"

export const ServiceListMessageStyles = {
  Container: css`
    overflow: hidden;

    gap: 8px;
    padding: 12px;


    border-radius: var(--border-radius-16);

    box-shadow: 0 2px 10px 0 var(--text-color-5);
  `,

  Container_Active: css`
    background-color: var(--main-color-5);

    border: 1px solid var(--main-color-10);
  `,

  Container_Disabled: css`
    background-color: var(--text-color-2);

    border: 1px solid var(--text-color-5);
  `
}